import { render, staticRenderFns } from "./CreateBookingCategory.vue?vue&type=template&id=b639ae92&scoped=true&"
import script from "./CreateBookingCategory.vue?vue&type=script&lang=js&"
export * from "./CreateBookingCategory.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=b639ae92&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639ae92",
  null
  
)

export default component.exports